import { BlogPost } from '../types';
import { getBlogPosts } from '../services/blogDiscovery';

// Legacy static blog posts (kept as fallback)
export const staticBlogPosts: BlogPost[] = [];

/**
 * Gets blog posts dynamically from markdown files
 * Falls back to static posts if dynamic loading fails
 */
export async function getBlogPostsData(): Promise<BlogPost[]> {
  try {
    const dynamicPosts = await getBlogPosts();
    return dynamicPosts.length > 0 ? dynamicPosts : staticBlogPosts;
  } catch (error) {
    console.error('Failed to load dynamic blog posts, falling back to static posts:', error);
    return staticBlogPosts;
  }
}

// Export static posts for backward compatibility
export const blogPosts = staticBlogPosts;
